import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.bsl = bracketIndenting({
	line: "//",
})
